import React, { useMemo } from 'react';
import _ from 'underscore';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { i18nKeys } from '@bingads-webui-react/file-picker';
import { StringUtils } from '@bingads-webui-clientcenter/common-utils';
import { TaxTypeFormPropTypes } from '../shapes';
import { GlobalTaxForm } from './global-taxform';
import { EmptyTaxForm } from './empty-taxform';
import { registerTaxform } from '../taxform-store';
import { EmptyViewTaxForm } from './viewtaxforms/empty-viewtaxform';
import { AMTaxViewTaxForm } from './viewtaxforms/armenia-viewtaxform';
import { CustomValidateItems } from '../validator';
import { withViewTaxFormWithFilledEmptyTaxValue, withTaxFormByPilot, getPilotStatus, addLegalIdentifierNumberInTaxSchema, getTaxTypeLabel } from '../utils';
import { GlobalTaxIdHelpPopUpId, FileScenarioMapping, GlobalTaxIdCountryCodeToPilots, LegalIdentifierHintI18nKey, LegalIdentifierNumberPilot, GlobalFilePickerRequiredErrorMessage } from '../constants';

const {
  TaxAMVatNumberRegExp, TaxType, CountryCode, TaxCertLabel, TaxLabelFormat,
} = Constants;
const { regexTest } = StringUtils;
const taxIdValidator = _.partial(regexTest, TaxAMVatNumberRegExp);

const taxSchemaGetter = ({ permissions }) => {
  const IsLegalIdentifierNumberPilotOn = getPilotStatus(LegalIdentifierNumberPilot, permissions);

  const taxSchema = {
    name: 'Armenia Taxation Validation Schema',
    type: 'object',
    properties: {
      [TaxType.VatNumber]: {
        type: 'string',
        required: false,
        helpPopupTopic: GlobalTaxIdHelpPopUpId,
      },
    },
  };

  if (IsLegalIdentifierNumberPilotOn) {
    addLegalIdentifierNumberInTaxSchema(taxSchema);
  }

  return taxSchema;
};

const AMTaxForm = ({
  i18n,
  onValidate,
  showLineByLineFormGroup,
  showTaxFilePicker,
  alwaysShowError,
  data,
  mtData,
  taxCertification,
  mtTaxCertification,
  urlBuilder,
  disabled,
  permissions,
}) => {
  const taxCertLabel = useMemo(() => i18n.getString(TaxCertLabel.TaxCertificateOrEquivalentProof), [i18n]);
  const taxTypeLabel = useMemo(() => getTaxTypeLabel(TaxType.VatNumber, i18n, { countryCode: CountryCode.AM }), [i18n]);
  const vatValidatorErrorMessage = useMemo(() => i18n.getString(CustomValidateItems.ArmeniaVATFormatValidation), [i18n]);
  const vatLabel = useMemo(() => getTaxTypeLabel(TaxType.VatNumber, i18n, { labelFormat: TaxLabelFormat.RequiredForBusiness, countryCode: CountryCode.AM }), [i18n]);
  const customStrings = useMemo(() => ({
    [i18nKeys.FilePicker_ErrorMessage_Required]: i18n.getString(GlobalFilePickerRequiredErrorMessage, {
      taxId: taxTypeLabel,
    }),
  }), [i18n, taxTypeLabel]);

  return (
    <GlobalTaxForm
      i18n={i18n}
      onValidate={onValidate}
      taxSchemaGetter={taxSchemaGetter}
      vatLabel={vatLabel}
      customStrings={customStrings}
      showLineByLineFormGroup={showLineByLineFormGroup}
      vatValidatorErrorMessage={vatValidatorErrorMessage}
      showTaxFilePicker={showTaxFilePicker}
      alwaysShowError={alwaysShowError}
      data={data}
      mtData={mtData}
      taxCertification={taxCertification}
      mtTaxCertification={mtTaxCertification}
      urlBuilder={urlBuilder}
      disabled={disabled}
      taxIdValidator={taxIdValidator}
      taxCertLabel={taxCertLabel}
      taxCertScenario={FileScenarioMapping.AM}
      showLegalIdentifierNumberField
      legalIdentifierHint={i18n.getString(LegalIdentifierHintI18nKey[CountryCode.AM])}
      permissions={permissions}
    />
  );
};

AMTaxForm.propTypes = TaxTypeFormPropTypes;

const pilotFlag = GlobalTaxIdCountryCodeToPilots.AM;
const TaxForm = withTaxFormByPilot({ pilotFlag, PilotForm: AMTaxForm, DefaultForm: EmptyTaxForm });
const ViewTaxForm = withTaxFormByPilot({ pilotFlag, PilotForm: AMTaxViewTaxForm, DefaultForm: EmptyViewTaxForm });

registerTaxform('/AM/', TaxForm, withViewTaxFormWithFilledEmptyTaxValue({ ViewTaxForm, getTaxSchema: taxSchemaGetter }));
